<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12>
        <gmap-map
          ref="mapRef"
          :center="mapCenter"
          :options="mapConfig"
          :zoom="16"
          map-type-id="roadmap"
          class="map-container"
          @center_changed="updateCenter"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in drivers"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            :label="m.label"
            :icon="{ url: m.url}"
            @click="onMarkerClicked(m)"
          />
        </gmap-map>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Service from "../../services";

import moment from "moment";
export default {
  props: {
    props: []
  },
  data() {
    return {
      loading: null,
      routeDialog: false,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      description: "",
      form: {
        lat: "",
        lng: "",
        shop_id: null,
        cluster_id: null
      },
      mapCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      origin: null,
      mapConfig: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
        zoom: 12
      },
      drivers: [],
      clusters: [],
      markers: [],
      routeData: null
    };
  },
  created() {
    Service.Driver.gets().then(res => {
      if (res.success) {
        this.drivers = res.data.map(item => {
          let label = {
            text: "#" + item.geohash,
            fontWeight: "bold"
          };
          let url = require("../../assets/img/marker-driver.png");

          if (item.status == "available") {
            url = require("../../assets/img/marker-man.png");
          }
          return {
            ...label,
            position: new google.maps.LatLng(item.latitude, item.longitude),
            url: url
          };
        });
      }
    });
    this.searchOrder();
  },
  methods: {
    searchOrder() {
      this.markers = [];

      let params = {
        shop_id: this.form.shop_id,
        cluster_id: this.form.cluster_id
      };

      /*
      let params = {
        shop_id: 73,
        cluster_id: 1
      };
      */

      var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      Service.Order.gets(queryString).then(res => {
        if (res.data.length > 0) {
          this.origin = {
            position: new google.maps.LatLng(
              res.data[0].shop.latitude,
              res.data[0].shop.longitude
            )
          };

          res.data.map(item => {
            if (
              item.status != "pending" &&
              item.status != "new" &&
              item.status != "cancelled"
            ) {
              let url = require("../../assets/img/marker-a.png");
              if (item.status == "cooking") {
                url = require("../../assets/img/marker-b.png");
              }
              this.markers.push({
                ...item,
                selected: false,
                label: {
                  text: "#" + item.order_id,
                  fontWeight: "bold"
                },
                info: item.delivery_info_json.whereTo.name,
                position: new google.maps.LatLng(
                  item.delivery_info_json.whereTo.lat,
                  item.delivery_info_json.whereTo.lng
                ),
                url: url,
                statusUrl: url
              });
            }
          });

          this.$refs.mapRef.$mapPromise.then(map => {
            map.panTo({
              lat: parseFloat(res.data[0].shop.latitude),
              lng: parseFloat(res.data[0].shop.longitude)
            });
          });
        }
      });
    },
    toggleSelect(index) {
      this.markers[index].selected = !this.markers[index].selected;
      if (this.markers[index].selected) {
        this.markers[index].url = require("../../assets/img/marker-c.png");
      } else {
        this.markers[index].url = this.markers[index].statusUrl;
      }
    },
    onShopChanged() {
      let index = this.shops.findIndex(x => x.shop_id == this.form.shop_id);
      this.clusters = this.shops[index].cluster_json;
    },
    onMarkerClicked(m) {
      let index = this.markers.findIndex(x => x.order_id == m.order_id);
      this.markers[index].selected = !this.markers[index].selected;

      if (this.markers[index].selected) {
        this.markers[index].url = require("../../assets/img/marker-c.png");
      } else {
        this.markers[index].url = this.markers[index].statusUrl;
      }
    },
    updateCenter(latLng) {
      this.form.lat = latLng.lat();
      this.form.lng = latLng.lng();
    },
    submit() {
      let selectedOrders = [];
      this.markers.map(item => {
        if (item.selected) {
          selectedOrders.push(item.order_id);
        }
      });

      if (selectedOrders.length < 1) {
        return;
      }

      let data = {
        scheduleAt: "asap",
        serviceType: "MOTORCYCLE",
        specialRequests: ["LALABAG"],
        requesterContact: {
          name: "Halalize Co",
          phone: "0922499203"
        },
        sms: true,
        shop_id: this.form.shop_id,
        cluster_id: this.form.cluster_id,
        orders: selectedOrders
      };

      this.showLoading();
      Service.Delivery.getClusterDriverFee(data).then(res => {
        console.log(res);
        if (res.success) {
          this.routeData = res.data;
          this.routeDialog = true;
        }
        this.hideLoading();
      });
    },
    requestDriver() {
      //console.log(JSON.stringify(this.routeData));
      this.showLoading();
      Service.Delivery.requestClusterDriver(this.routeData).then(res => {
        console.log(res);
        if (res.success) {
          this.routeDialog = false;
        }
        this.hideLoading();
      });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.map-container {
  height: calc(100vh - 12vh);
}

.control {
  padding: 0;
  position: absolute;
  top: 10px;
  z-index: 99;
  width: 100%;
}

.fixed-card {
  position: relative;
  background-color: #eee;
  overflow-y: auto;
  height: calc(100vh - 12vh);
}
</style>